<template>
  <SwitchFlag
    :value="value"
    :label-mapping="labelMapping"
    v-on="$listeners" />
</template>
<script>
import SwitchFlag from '@/components/SiteSettings/SiteSettingsSwitchFlag';
import { isObject } from 'lodash';
export default {
  name: 'AppSwitcher',
  components: {
    SwitchFlag,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    /**
     * @type {string|object}
     * @see labelMapping
     */
    labelText: {
      type: [String, Object],
      default: '',
    },
  },
  computed: {
    labelMapping() {
      if (isObject(this.labelText)) {
        return this.labelText;
      }
      return {
        on: this.labelText,
        off: this.labelText,
      };
    },
  },
};
</script>
